import React from 'react'
import { useTranslation } from 'react-i18next'
import selfCheckInIcon from '../../assets/images/loginBackground/self-check-in.png'

const CheckInComplete = () => {
    const { t } = useTranslation()

    return (
        <div className='h-screen bg-white flex flex-col items-center pt-30'>
            <div className='flex flex-col items-center pt-40 px-6'>
                <img
                    src={selfCheckInIcon}
                    alt='Check In Complete'
                    className='w-40 h-40'
                />

                <h1 className='text-3xl font-semibold text-center mt-8'>
                    {t('checkInCompleteTitle')}
                </h1>

                <p className='text-center mt-4 max-w-xs'>
                    {t('checkInCompleteMessage')}
                </p>
            </div>
        </div>
    )
}

export default CheckInComplete